import { gql } from '@apollo/client';

export const GET_APPLICABLE_REPORT_CARD_SCHEMA = gql`
  query GetApplicableReportCardSchema(
    $assessmentId: ID
    $ageGroupId: ID
    $positionId: ID
    $token: String
  ) {
    getApplicableReportCardSchema(
      assessmentId: $assessmentId
      ageGroupId: $ageGroupId
      positionId: $positionId
      token: $token
    ) {
      id
      name
      version
      layout {
        type
        props
        children
        dataKey
        required
        fallbackComponent
        staticData
        supportedReportCardLevels
      }
      styling {
        theme
        customStyles
      }
      dataSources
    }
  }
`;
